export default "__VITE_ASSET__BS2E_oiM__"